import { render, staticRenderFns } from "./TextIcon.vue?vue&type=template&id=763dbe2a&"
import script from "./TextIcon.vue?vue&type=script&lang=ts&"
export * from "./TextIcon.vue?vue&type=script&lang=ts&"
import style0 from "./TextIcon.vue?vue&type=style&index=0&id=763dbe2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports